import type { EndpointsRegistry, FetchClient } from '~/api/types'
import { GatewayEndpoints } from '~/api/endpoints/gateway-endpoints'
import type { Site, Zone, CreateSitePayload } from '~/types/locations'
import type { SuccessNoContent } from '~/types/common'

export interface LocationsService {
  getSites: () => Promise<Site[]>
  getSiteById: (siteId: number) => Promise<Site>
  createSite: (payload: CreateSitePayload) => Promise<Site>
  updateSite: (siteId: number, payload: Partial<CreateSitePayload>) => Promise<Site>
  deleteSite: (siteId: number) => Promise<SuccessNoContent>
  getSiteZones: (siteId: number) => Promise<Zone[]>
}

export const registerEndpoints = (client: FetchClient, registry: EndpointsRegistry): LocationsService => {
  return {
    getSites: async () => {
      const { url, method, headers, body } = registry.createRequest(GatewayEndpoints.SITES_GET_ALL)
      return await client<Site[]>(url, { method, headers, body })
    },
    getSiteById: async (siteId: number) => {
      const { url, method, headers, body } = registry.createRequest(GatewayEndpoints.SITE_GET_BY_ID, {
        params: { siteId }
      })
      return await client<Site>(url, { method, headers, body })
    },
    createSite: async (payload: CreateSitePayload) => {
      const { url, method, headers, body } = registry.createRequest(GatewayEndpoints.SITE_CREATE, {}, payload)
      return await client<Site>(url, { method, headers, body })
    },
    updateSite: async (siteId: number, payload: Partial<CreateSitePayload>) => {
      const { url, method, headers, body } = registry.createRequest(
        GatewayEndpoints.SITE_UPDATE,
        { params: { siteId } },
        payload
      )
      return await client<Site>(url, { method, headers, body })
    },
    deleteSite: async (siteId: number) => {
      const { url, method, headers, body } = registry.createRequest(GatewayEndpoints.SITE_DELETE, {
        params: { siteId }
      })
      return await client<SuccessNoContent>(url, { method, headers, body })
    },
    getSiteZones: async (siteId: number) => {
      const { url, method, headers, body } = registry.createRequest(GatewayEndpoints.ZONES_GET_BY_SITE_ID, {
        params: {
          siteId
        }
      })
      return await client<Zone[]>(url, { method, headers, body })
    }
  }
}
